import gql from 'graphql-tag';
import { cloneDeep } from 'lodash-es';

export const GET_ADVOCACY_CAMPAIGN = gql`
  query getAdvocacyCampaign($stateAbbreviation: String!) {
    state(abbreviation: $stateAbbreviation) {
      activeAdvocacyCampaign {
        callToActionText
        editableBody
        id
        isDefault
        legislationDescription
        numberOfSubmissions
        shareText
        subjectLine
        successMessage
        successTitle
        uneditableBody
      }
    }
  }
`;

export const getAdvocacyCampaignMock = {
  state: {
    activeAdvocacyCampaign: {
      callToActionText: 'Do it!',
      editableBody: 'Things the customer might want to write to a rep.',
      id: 1,
      isDefault: true,
      legislationDescription:
        'This bill will bring community solar to your state.',
      numberOfSubmissions: 32,
      shareText: 'Join me in supporting community solar legislation',
      subjectLine: 'Vote for community solar',
      successMessage: 'Thank you for your support!',
      successTitle: 'You supported clean energy legislation',
      uneditableBody: 'Things the customer will definitely write to a rep.',
    },
  },
};

const getUnderSupportedAdvocacyCampaignMock = cloneDeep(
  getAdvocacyCampaignMock
);
getUnderSupportedAdvocacyCampaignMock.state.activeAdvocacyCampaign.numberOfSubmissions = 9;

const getSpecialAdvocacyCampaignMock = cloneDeep(getAdvocacyCampaignMock);
getSpecialAdvocacyCampaignMock.state.activeAdvocacyCampaign.isDefault = false;

export {
  getUnderSupportedAdvocacyCampaignMock,
  getSpecialAdvocacyCampaignMock,
};
